import React from 'react';

import AiChatDrawer from './AiChatDrawer';
import AiOpsChatIframeDrawer from './AiOpsChatIframeDrawer';

function hasAiOpsChatOrigin(): boolean {
  return Boolean(window.configs?.AI_OPS_CHAT_ORIGIN?.trim());
}

export default function AiChatEntry() {
  if (hasAiOpsChatOrigin()) {
    return <AiOpsChatIframeDrawer />;
  }

  return <AiChatDrawer />;
}
